export default {
    T001: 'TERMINAL_NOT_FOUND',
    T002: 'DEVICE_ID_ALREADY_EXIST',
    T003: 'TERMINAL_ALREADY_ASSIGNED',
};
